export var entityFromOptionMenuItem = function (item) {
  var _a;
  return (_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.entity;
};